import { render, staticRenderFns } from "./MotDePasseOublieFromNotaire.vue?vue&type=template&id=4efb058b"
import script from "./MotDePasseOublieFromNotaire.vue?vue&type=script&lang=ts"
export * from "./MotDePasseOublieFromNotaire.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports